import FingerprintJS from '@fingerprintjs/fingerprintjs';

const DEVICE_FINGERPRINT_KEY = 'b8236d3d-eef7-46f7';

let cachedFingerprint: string | null = null; // In-memory cache

export async function getCachedDeviceId(): Promise<string> {
  
    // First: return from memory if available
    if (cachedFingerprint) return cachedFingerprint;

    // Second: try localStorage
    const stored = localStorage.getItem(DEVICE_FINGERPRINT_KEY);
    if (stored) {
        cachedFingerprint = stored;
        return cachedFingerprint;
    }

    // Third: generate new fingerprint
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    cachedFingerprint = result.visitorId;
    
    // Save to localStorage
    localStorage.setItem(DEVICE_FINGERPRINT_KEY, cachedFingerprint);

    return cachedFingerprint;
}
